import { render, staticRenderFns } from "./SignDocuments.vue?vue&type=template&id=441578c4&scoped=true"
import script from "./SignDocuments.vue?vue&type=script&lang=js"
export * from "./SignDocuments.vue?vue&type=script&lang=js"
import style0 from "./SignDocuments.vue?vue&type=style&index=0&id=441578c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441578c4",
  null
  
)

export default component.exports